import React from 'react';
import { useDarkMode } from './hooks';
import { ThemeProvider } from 'styled-components';
import lightTheme from './theming/themeContext';
import GlobalStyles from './theming/global';
import { AppWrapper, Landing, Scheduler, About, Dubi, Dira, WebJourney } from './pages';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import GodfreyAI from './components/GodfreyAI';
import usePageTracking from './hooks/usePageTracking';

const PageTracker = () => { usePageTracking(); return null; };

const App = () => {
    const [
        mode,
        toggleMode,
        spread,
        componentMounted,
        setDisableScroll,
    ] = useDarkMode();
    if (!componentMounted) {
        return <div />;
    }

    return (
        <ThemeProvider theme={lightTheme}>
            <GlobalStyles />
            <BrowserRouter>
                <PageTracker />
                <Routes>
                    <Route
                        exact
                        path='/'
                        element={
                            <AppWrapper>
                                <Landing
                                    setDisableScroll={setDisableScroll}
                                    spread={spread}
                                    mode={mode}
                                    toggleMode={toggleMode}
                                />
                            </AppWrapper>
                        }
                    />

                    <Route
                        path='/partner-portal'
                        element={
                            <AppWrapper>
                                <Scheduler
                                    setDisableScroll={setDisableScroll}
                                    spread={spread}
                                    mode={mode}
                                    toggleMode={toggleMode}
                                />
                            </AppWrapper>
                        }
                    />
                    <Route
                        path='/dira'
                        element={
                            <AppWrapper>
                                <Dira
                                    spread={spread}
                                    mode={mode}
                                    toggleMode={toggleMode}
                                />
                            </AppWrapper>
                        }
                    />
                    <Route
                        path='/dubi'
                        element={
                            <AppWrapper>
                                <Dubi
                                    spread={spread}
                                    mode={mode}
                                    toggleMode={toggleMode}
                                />
                            </AppWrapper>
                        }
                    />
                    <Route
                        path='/web-journey'
                        element={
                            <AppWrapper>
                                <WebJourney
                                    spread={spread}
                                    mode={mode}
                                    toggleMode={toggleMode}
                                />
                            </AppWrapper>
                        }
                    />
                    <Route
                        path='/about'
                        element={
                            <AppWrapper>
                                <About
                                    spread={spread}
                                    mode={mode}
                                    toggleMode={toggleMode}
                                />
                            </AppWrapper>
                        }
                    />
                    <Route path='*' element={<Navigate to='/' replace />} />
                </Routes>
            </BrowserRouter>
            <GodfreyAI />
        </ThemeProvider>
    );
};

export { App };
